import React from "react"
import { Form, Select } from "antd"
import { faDatabase } from "@fortawesome/free-solid-svg-icons"
import DataQButton from "shared/ui/Buttons/DataQButton.component"
import FormatPanelHeader from "./FormatPanelHeader.component"
import { DATA_FORMAT } from "types/engineExport.types"
import { InputValues } from "features/QueryConsole/api/useExportDataModal"

interface DqdExportPanelProps {
  inputValues: InputValues
  onInputChange: <K extends keyof InputValues>(key: K, value: InputValues[K]) => void
  onExport: () => Promise<void>
  isExporting: boolean
}

const DqdExportPanel: React.FC<DqdExportPanelProps> = ({
  inputValues,
  onInputChange,
  onExport,
  isExporting,
}) => (
  <div className="flex flex-col">
    <FormatPanelHeader
      icon={faDatabase}
      title="Export as DQD"
      tagLabel="Internal"
      tagColor="cyan"
      description="DATA(Q) internal binary format. Optimized for fast loading in DATA(Q) dashboards."
    />
    <Form layout="vertical">
      <Form.Item label="Data Format">
        <Select
          value={inputValues.dataFormat}
          onChange={(value: DATA_FORMAT) => onInputChange("dataFormat", value)}
          options={[
            { value: DATA_FORMAT.CATEGORIZED, label: "Categorized (Default)" },
            { value: DATA_FORMAT.EXPANDED, label: "Expanded" },
          ]}
        />
      </Form.Item>
    </Form>
    <div className="border-t border-gray-100 pt-4 mt-1">
      <DataQButton
        type="primary"
        onClick={onExport}
        isLoading={isExporting}
        aria-label="Export data as DQD file"
      >
        Export DQD
      </DataQButton>
    </div>
  </div>
)

export default DqdExportPanel
